import PreviewCardHeader from 'Components/Common/PreviewCardHeader'
import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { Card, CardBody, Col, Container, Row, Table } from 'reactstrap'
import { fetchUserList } from 'slices/users/thunk'
import { AppDispatch, RootState } from 'store'
import InfiniteScroll from "react-infinite-scroll-component";
import useDocumentTitle from 'hooks/useDocumentTitle'
import { User } from 'types/users'
import { deleteUser as deleteUserAPI } from 'services/api/users'
import { toast } from 'react-toastify'
import { getErrorMessage } from 'utils/helpers'
import Swal from "sweetalert2";
import AccessControl from 'wrappers/AccessControl'
import { PRIVILEGE } from 'constants/privilege'
import { usePrivileges } from 'hooks/useAuth'
const UsersList = () => {
    const dispatch: AppDispatch = useDispatch();
    useDocumentTitle("Users");
    const privileges = usePrivileges();

    const { list: users, has_more, page } = useSelector((state: RootState) => state.users);
    const selectedHubId = useSelector((state: RootState) => state.auth.selectedHubId);

    const fetchUsers = useCallback(async (page: number, force: boolean = false) => {
        dispatch(fetchUserList({ page, force }));
    }, [dispatch])

    useEffect(() => {
        fetchUsers(1);
    }, [fetchUsers])


    const nextPage = () => {
        if (has_more) {
            const nextPageNumber = page + 1;
            fetchUsers(nextPageNumber);
        }
    }

    const currentUser = useSelector((state: RootState) => state.auth.user);


    const deleteUser = async (user: User) => {

        if (currentUser?.uuid === user.uuid || !selectedHubId || !privileges.includes(PRIVILEGE.HUB.USER.DESTROY)) return;

        const result = await Swal.fire({
            title: 'Are you sure you want to delete this user?',
            text: "there is no undo after deleting the user",
            iconHtml: `<svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="40" cy="40" r="40" fill="#F1F5F4" />
            <path d="M43 47L31 48L26 51C26 52.6667 26.2 56.2 27 57C27.8 57.8 34.6667 58.6667 38 59L51 57L54 53L52 49L43 47Z" fill="#BBD8ED" />
            <path fillRule="evenodd" clipRule="evenodd" d="M39.9699 46.6875C32.2346 46.6875 25.6289 47.857 25.6289 52.5408C25.6289 57.2246 32.1927 58.4361 39.9699 58.4361C47.7051 58.4361 54.3089 57.2646 54.3089 52.5827C54.3089 47.9008 47.747 46.6875 39.9699 46.6875Z" stroke="#00A7E4" strokeLinecap="round" strokeLinejoin="round" />
            <path fillRule="evenodd" clipRule="evenodd" d="M39.9698 40.0079C45.046 40.0079 49.1603 35.8917 49.1603 30.8155C49.1603 25.7393 45.046 21.625 39.9698 21.625C34.8936 21.625 30.7774 25.7393 30.7774 30.8155C30.7603 35.8745 34.8479 39.9907 39.905 40.0079H39.9698Z" stroke="#0069AD" strokeLinecap="round" strokeLinejoin="round" />
        </svg>`,
            showCancelButton: true,
            confirmButtonText: "Yes, Delete",
            cancelButtonText: "No",
            confirmButtonColor: '#fa896b'
        });

        if (result.isConfirmed) {
            try {
                await deleteUserAPI(selectedHubId!, user.uuid);
                toast.success("User removed successfully!");
                fetchUsers(1, true);
            } catch (error) {
                console.log(error);
                toast.error(getErrorMessage(error, "Failed to remove user"));
            }
        }
    }


    return (
        <div className="page-content">
            <Container fluid>
                <Row>
                    <Col xl={12}>
                        <Card>
                            <PreviewCardHeader title="Users" rightContent={<AccessControl privilege={PRIVILEGE.HUB.USER.CREATE}><Link className='btn btn-sm btn-primary' to={{ pathname: '/user/create' }}>Create</Link></AccessControl>} />
                            <CardBody>
                                <InfiniteScroll
                                    dataLength={users.length}
                                    next={nextPage}
                                    hasMore={has_more}
                                    loader={<></>}
                                    className="w-100"
                                >
                                    <div className="table-responsive">
                                        <Table className="align-middle table-nowrap mb-0">
                                            <thead>
                                                <tr>
                                                    <th scope="col">Name</th>
                                                    <th scope="col">Email</th>
                                                    <th scope="col">Role</th>
                                                    <th scope="col"></th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                                {
                                                    users.map((user, i) => {
                                                        return (
                                                            <tr key={i}>
                                                                <td>{user.name}</td>
                                                                <td>{user.email}</td>
                                                                <td>{user.role?.name}</td>
                                                                <td>
                                                                    {
                                                                        user.uuid !== currentUser?.uuid &&
                                                                        <div className="d-flex align-items-center gap-2">
                                                                            <AccessControl privilege={PRIVILEGE.HUB.USER.EDIT}>
                                                                                <Link to={{ pathname: `/user/${user.uuid}` }}>
                                                                                    <i className='mdi mdi-circle-edit-outline fs-5'></i>
                                                                                </Link>
                                                                            </AccessControl>
                                                                            <AccessControl privilege={PRIVILEGE.HUB.USER.DESTROY}>
                                                                                <span onClick={() => deleteUser(user)} className='text-danger cursor-pointer'>
                                                                                    <i className='mdi mdi-delete fs-5'></i>
                                                                                </span>
                                                                            </AccessControl>
                                                                        </div>
                                                                    }
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                            </tbody>
                                        </Table>
                                    </div>
                                </InfiniteScroll>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default UsersList